<template>
  <div class="page-card">
    <el-card>
      <div slot="header">系统管理 - 管理员账号</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="用户名">
          <el-input v-model="query.username" placeholder="用户名" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="openEdit()">新增管理员</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="username" label="用户名" />
        <el-table-column prop="role" label="角色" />
        <el-table-column prop="status" label="状态" />
        <el-table-column prop="lastLoginAt" label="最后登录时间" width="180" />
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="toggleStatus(scope.row)">
              {{ scope.row.status === '正常' ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="editForm.id ? '编辑管理员' : '新增管理员'"
        :visible.sync="editVisible"
        width="500px"
      >
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="用户名">
            <el-input
              v-model="editForm.username"
              :disabled="!!editForm.id"
            />
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="editForm.role" placeholder="请选择角色">
              <el-option label="超级管理员" value="super" />
              <el-option label="运营" value="operator" />
              <el-option label="只读" value="viewer" />
            </el-select>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="editForm.password" type="password" placeholder="不修改请留空" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveAdmin">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'AdminUserList',
  data() {
    return {
      query: {
        username: ''
      },
      list: [],
      editVisible: false,
      editForm: {
        id: null,
        username: '',
        role: 'operator',
        password: ''
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request.get('/admin-users', { params: this.query }).then(res => {
        const data = res.data || res
        this.list = (data && data.items) || []
      })
    },
    resetQuery() {
      this.query.username = ''
      this.fetchList()
    },
    openEdit(row) {
      if (row) {
        this.editForm = {
          id: row.id,
          username: row.username,
          role: row.role || 'operator',
          password: ''
        }
      } else {
        this.editForm = {
          id: null,
          username: '',
          role: 'operator',
          password: ''
        }
      }
      this.editVisible = true
    },
    toggleStatus(row) {
      const target = row.status === '正常' ? '禁用' : '正常'
      request
        .put(`/admin-users/${row.id}/status`, { status: target })
        .then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
    },
    saveAdmin() {
      if (!this.editForm.username) {
        this.$message.warning('请输入用户名')
        return
      }
      if (!this.editForm.id && !this.editForm.password) {
        this.$message.warning('请设置初始密码')
        return
      }
      const payload = {
        username: this.editForm.username,
        role: this.editForm.role
      }
      if (this.editForm.password) {
        payload.password = this.editForm.password
      }
      const req = this.editForm.id
        ? request.put(`/admin-users/${this.editForm.id}`, payload)
        : request.post('/admin-users', payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.editVisible = false
        this.fetchList()
      })
    }
  }
}
</script>

